import { useCallback, useEffect, useState } from 'react';

import { useDialogs } from '~entities/dialogs';
import { useUserId } from '~hooks/useUserId';
import { userApi } from '~services/api/user';

export const useSetLastBotId = (): ((lastBotId: string) => void) => {
	const userId = useUserId();

	const [trigger] = userApi.useSetLastBotIdMutation();

	return useCallback(
		(value: string) => {
			void trigger({
				userId,
				lastBotId: value,
			});
		},
		[trigger, userId]
	);
};

export const useLastBotId = () => {
	const userId = useUserId();
	const { data, isSuccess: isUserConfigSuccess } = userApi.useUserConfigQuery(
		{
			userId,
		},
		{
			skip: !userId,
		}
	);
	const { bots, isSuccess: isDialogsSuccess } = useDialogs();
	const [value, setValue] = useState<string | undefined>();

	useEffect(() => {
		const value = data?.lastBotChatId;
		if (isUserConfigSuccess && isDialogsSuccess && value) {
			const isActiveBot = bots.find(
				(bot) => bot.clientId === +value && !bot.disabledByLevel
			);
			setValue(isActiveBot ? value : undefined);
		}
	}, [isUserConfigSuccess, isDialogsSuccess, data, bots]);

	return {
		isSuccess: isDialogsSuccess && isUserConfigSuccess,
		lastBotId: value,
	};
};
